<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer010">
<p class="basic-paragraph"><span class="charoverride4"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride4">Dedication</span></h1>
<p class="basic-paragraph"><span class="charoverride5"><br class="calibre1"/></span></p>
<p class="basic-paragraph"><span class="charoverride5"><br class="calibre1"/></span></p>
<p class="basic-paragraph"><span class="charoverride5">For educators everywhere, especially the ones who influenced me:</span></p>
<p class="basic-paragraph"><span class="charoverride5">Marion A. Porter</span></p>
<p class="basic-paragraph"><span class="charoverride5">Gilbert Morales</span></p>
<p class="basic-paragraph"><span class="charoverride5">Carroll Dirkes</span></p>
<p class="basic-paragraph"><span class="charoverride5">Leo Eves</span></p>
<p class="basic-paragraph"><span class="charoverride5">Bob Musick</span></p>
<p class="basic-paragraph"><span class="charoverride5">James F. Hornig</span></p>
<p class="basic-paragraph"><span class="charoverride5">Sunney I. Chan</span></p>
<p class="basic-paragraph"><span class="charoverride5">Theodore Von Laue</span></p>
<p class="basic-paragraph"><span class="charoverride5">David A. Shirley</span></p>
<p class="basic-paragraph"><span class="charoverride5">Norman Edelstein</span></p>
<p class="basic-paragraph"><span class="charoverride5">William Weltner, Jr.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?ffca30f0